import firebase from 'firebase'
import firestore from 'firebase/firestore'

// Initialize Firebase
var config = {
  apiKey: "AIzaSyACVgT4ZqMHzWx2Oh29in6X0E61DzdcFbw",
  authDomain: "ninja-smoothies-e4dc0.firebaseapp.com",
  databaseURL: "https://ninja-smoothies-e4dc0.firebaseio.com",
  projectId: "ninja-smoothies-e4dc0",
  storageBucket: "ninja-smoothies-e4dc0.appspot.com",
  messagingSenderId: "734999152088"
};
const firebaseApp = firebase.initializeApp(config);
firebaseApp.firestore().settings( { timestampsInSnapshots: true } );

// export firestore database

export default firebaseApp.firestore()



// WEBPACK FOOTER //
// ./src/firebase/init.js